var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(" Dovolali ste sa? ")])]), _c('div', {
    staticClass: "input-block pointer",
    on: {
      "click": function click($event) {
        return _vm.setContactedResult(true);
      }
    }
  }, [_vm._v(" áno ")]), _c('div', {
    staticClass: "input-block pointer",
    on: {
      "click": function click($event) {
        return _vm.setContactedResult(false);
      }
    }
  }, [_vm._v(" nie ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }